import { useDecision } from "@optimizely/react-sdk"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { useRecoilState } from "recoil"
import { Button, Col, Row } from "../App.styles"
import {
    RowInfo,
    Spinner,
} from "../common"
import {
    highlightIdState,
    useChallengesQuery,
    useCreateMutation,
    useSuggestMutation,
} from "./Organize.state"
import SuggestChallengeModal from "./modals/SuggestChallengeModal"
import { Typography } from "@material-ui/core"
import EmptyPage from "../common/EmptyPage"
import { ReactComponent as EmptyChallenge } from "../images/empty-challenges.svg"
import { ChallengeHeader } from "./Organize.styles"

const OrganizeEmpty = () => {
    const { game_id } = useParams()
    const { t } = useTranslation()
    const [, setOpenId] = useState()
    const [, setHighlightId] = useRecoilState(highlightIdState)
    const data = useChallengesQuery(game_id)
    const { isCreating, create } = useCreateMutation()
    const { isSuggesting, suggest } = useSuggestMutation()
    const [decisionAi] = useDecision('ai')

    const onCreate = async () => {
        const {
            data: { id },
        } = await create()
        setOpenId(id)
        setHighlightId(id)
    }

    const onSuggest = async () => {
        const {
            data: { id },
        } = await suggest()
        setOpenId(id)
        setHighlightId(id)
    }

    return (
        <EmptyPage>
            <EmptyChallenge />
            <div>
                <Typography className="text-center mb-4">{t(`You have no challenge yet`)}</Typography>
                {
                    decisionAi?.enabled
                        ? (
                            <ChallengeHeader>
                                <Row className="flex-grow-1 g-2">
                                    <Col className="col--stretch col-12 col-lg-auto">
                                        <Button data-testid="challenge__add-new" size="lg" className="btn--flat btn--flat-sm d-block flex-grow-1" color="primary" onClick={onCreate} disabled={isCreating || isSuggesting}>
                                            {t('Add Challenge')} {isCreating && <Spinner size="0.875rem" />}
                                        </Button>
                                    </Col>
                                    <Col className="col--stretch col-new-challenge__wrapper col-12 col-lg-auto">
                                        <div className="mt-2 mt-lg-0 flex-grow-1">
                                            <RowInfo help={<SuggestChallengeModal />} colClassName="col--stretch" isFull>
                                                <Button data-testid="challenge__suggest-new" size="lg" className="btn--flat btn--flat-sm d-block flex-grow-1 ml-2" color={data?.length > 3 ? 'success' : 'danger'} onClick={onSuggest} disabled={isSuggesting || isCreating}>
                                                    {t('Suggest Challenge')} {isSuggesting && <Spinner size="0.875rem" />}
                                                </Button>
                                            </RowInfo>
                                        </div>
                                    </Col>
                                </Row>
                            </ChallengeHeader>
                        )
                        : (
                            <>
                                <Button data-testid="challenge__add-new" size="lg" className="btn--flat btn--flat-sm d-block w-100" color="primary" onClick={onCreate} disabled={isCreating}>
                                    {t('Add New Challenge')} {isCreating && <Spinner size="0.875rem" />}
                                </Button>
                            </>
                        )
                }
            </div>
        </EmptyPage>
    )
}

export default OrganizeEmpty
